import React, {useCallback, useEffect, useState} from "react";
import {uniqueId} from "lodash";

import {format} from 'date-fns'
import {format as timezone} from 'date-fns-tz';

import Upload from "components/Dropzone"
import FileList from 'components/FileList';
import PaginationTable from "components/Pagination";
import Loading from "components/Loading";

import {getFiles} from "services/Files.service";
import {useUser} from "store/providers/app";

import api from "services/api";
import {i18n} from "translate/i18n";
import {useQuery, useQueryClient} from "react-query";
import {toast} from "react-toastify";


const Archives = ({selectedIndicator, selectedGoal, param, types}) => {

    const {user} = useUser();
    const queryClient = useQueryClient();
    const type = param === 'goals' ? 'goal' : 'indicator'

    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [paginate, setPaginate] = useState([])

    let selected = '';

    param === 'goals' ? selected = selectedGoal : selected = selectedIndicator

    const filter = selected?.replace('+', '%2B');

    useEffect(() => {
        setCurrentPage(1)
    }, [selected])

    const {isLoading, isFetching} = useQuery([param, currentPage, filter],
        () => {
            return getFiles(filter, currentPage, param, type)
        }, {
            onSuccess: (res) => {
                const {data} = res

                setPaginate({
                    from: data.from,
                    to: data.to,
                    total: data.total
                })
                const files = data.data

                const filter = files.filter(item => item.type === type)

                dataFiles(filter);
            },
            onError: (err) => {

                console.log('err', err.response)
                toast.error(i18n.t('error.badRequest'));
            },
            retry: false,
            refetchOnWindowFocus: false,
            keepPreviousData: true,
        })


    const dataFiles = (response) => {
        setUploadedFiles(
            response.map(file => (
                {
                    id: file.id,
                    filename: file.original,
                    created_at: format(new Date(file.created_at), 'dd/MM/yyyy - HH:mm'),
                    title: param === 'goals' ? file.goals : file.indicators,
                    username: file.username,
                    uploaded: true,
                    url: file.url,
                }
            ))
        );
    }

    const handleUpload = files => {

        const znDate = timezone(new Date(), 'dd/MM/yyyy - HH:mm', {
            timeZone: 'America/Sao_Paulo',
        });

        const newFile = files.map(file => ({
                file,
                id: uniqueId(),
                filename: file.name,
                created_at: znDate,
                title: null,
                username: user.username,
                progress: 0,
                uploaded: false,
                error: false,
                url: "",
            }
        ))

        setUploadedFiles((state) => state.concat(newFile))
        newFile.forEach(processUpload);
    };

    const updateFile = useCallback((id, data) => {
        setUploadedFiles((state) =>
            state.map((file) => (file.id === id ? {...file, ...data} : file))
        );
    }, []);

    const processUpload = (uploadedFile) => {
        const data = new FormData();
        data.append('file', uploadedFile.file, uploadedFile.filename);
        data.append('username', uploadedFile.username);

        let link = '/goals';

        if(param === 'indicators') {
            link = '/indicators/createbyfile'
        }

        api.post(link, data, {
            onUploadProgress: e => {
                const progress = parseInt(Math.round((e.loaded * 100) / e.total));
                updateFile(uploadedFile.id, {progress});
            }
        }).then((response) => {

            updateFile(uploadedFile.id, {
                uploaded: true,
                id: response?.data.file_id,
                url: response?.data.spreadsheetFile.url,
                title: response?.data.spreadsheetFile.indicators
            });

            queryClient.invalidateQueries([param, currentPage, filter])

        }).catch((err) => {
            updateFile(uploadedFile.id, {
                error: true,
            });
        });
    };

    const handlePageClick = (event) => {
        setCurrentPage(event.selected + 1)
    };

    if (isLoading) return <Loading/>

    return (
        <>
            <div className="card my-3 border-0 shadow-sm">
                <div className="card-body">
                    <Upload onUpload={handleUpload} types={types}/>
                </div>
            </div>

            <div className="card border-0 shadow-sm">
                <div className="card-header bg-primary fs-5 py-3 text-uppercase">
                    {i18n.t('label.archives')}
                </div>

                <div className="card-body p-0 table-responsive">
                    <FileList files={uploadedFiles} isFetching={isFetching} param={param}/>
                </div>

                <div className="card-footer border-top-0 bg-white">
                    <PaginationTable
                        paginate={paginate}
                        isFetching={isFetching}
                        handlePageClick={handlePageClick}
                    />
                </div>
            </div>
        </>
    );
}

export default Archives;

